import { render, staticRenderFns } from "./RowWidget.vue?vue&type=template&id=3153a1fa&scoped=true"
import script from "./RowWidget.vue?vue&type=script&lang=js"
export * from "./RowWidget.vue?vue&type=script&lang=js"
import style0 from "./RowWidget.vue?vue&type=style&index=0&id=3153a1fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3153a1fa",
  null
  
)

export default component.exports